export const profileTabLabels = {
    "about": "About / Links",
    "content": "Newsletter",
  };